
<script>
import confirmButton from "../buttons/confirm-button.vue";
export default {
    props:{
        id:String,
        size:{
            type: String,
            default: null
        },
        title:{
            type: String,
            default: 'Mi modal'
        },
        labelConfirmBtn:{
            type: String,
            default: 'Save'
        },
        labelCancelBtn:{
            type: String,
            default: 'Cancel'
        },
        titleClass:{
            type: String,
            default: 'text-dark font-18'
        },
        showConfirmButton:{
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            
        };
    },
    components: {
        confirmButton
    },
    emits:['confirm', 'cancel', 'shown', 'hidden'],
    methods:{
        confirm(){
            this.$emit("confirm");
        },
        cancel(){
            this.$emit("cancel");
        },
        shown(){
            this.$emit("shown");
        },
        hidden(){
            this.$emit("hidden");
        }
    }
}
</script>
<template>
    <!-- Modal -->
    <b-modal
      :id="id"
      :title="title"
      :title-class="titleClass"
      no-close-on-backdrop
      no-close-on-esc  
      @shown="shown"   
      @hidden="hidden"
      scrollable
      :size="size"
    >
        <form @submit.prevent="confirm" autocomplete="off">
            <slot></slot>
        </form>
        <template #modal-footer>
            <b-button
                variant="secondary"
                size="sm"
                class="float-right"
                @click="cancel"
            >
                {{labelCancelBtn}}
            </b-button>
            <confirmButton v-if="showConfirmButton" :label="labelConfirmBtn" btn-class="btn float-right btn-primary btn-sm" @click="confirm"></confirmButton>            
        </template>
    </b-modal>
    <!-- end modal -->
</template>